// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"786f91ef","561":"dbc6128e","674":"3faba969","902":"43cfd053"}[chunkId] + ".chunk.js";
};